/* settings: перевод строк интерфейса. Ключ — русская строка ровно как в коде.
   Окна «Настройки», «Общие сведения», «Настройки пользователей/команды», роли и права, левое меню настроек. */
const d: Record<string, string> = {
  // роли и права (roles.ts, auth ROLE_LABELS)
  "Владелец": "Owner",
  "Администратор": "Admin",
  "Менеджер": "Manager",
  "Агент": "Agent",
  "Наблюдатель": "Viewer",
  "Наблюдатель видит все диалоги, контакты и отчёты, но ничего не меняет и не пишет клиентам.":
    "A viewer sees all conversations, contacts and reports but cannot change anything or message customers.",
  "Агент видит только диалоги, назначенные ему, и отвечает клиентам. Настройки рабочего пространства ему недоступны.":
    "An agent sees only conversations assigned to them and replies to customers. Workspace settings are not available.",
  "Менеджеры имеют доступ ко всем разделам рабочего пространства, включая настройки. При этом они не могут приглашать или удалять других менеджеров и удалять каналы.":
    "Managers have access to every section of the workspace, including settings, but cannot invite or remove other managers or delete channels.",
  "Администратор управляет каналами, интеграциями, участниками и оплатой. Полный доступ ко всем настройкам рабочего пространства.":
    "An admin manages channels, integrations, members and billing. Full access to all workspace settings.",
  "Доступ к оплате": "Billing access",
  "Может смотреть счета, тариф и историю платежей.": "Can view invoices, the plan and payment history.",
  "Управление каналами": "Manage channels",
  "Может подключать, отключать и перенастраивать каналы.": "Can connect, disconnect and reconfigure channels.",
  "Управление участниками": "Manage members",
  "Менеджер с этим правом добавляет агентов и отзывает у них доступ.": "A manager with this permission adds agents and revokes their access.",
  "Экспорт данных": "Data export",
  "Может запрашивать выгрузку контактов и диалогов.": "Can request exports of contacts and conversations.",
  "Один владелец": "One owner",
  "Владельца нельзя отключить или сменить ему роль. Владельцы задаются на сервере (OWNER_EMAILS).":
    "The owner cannot be disabled or have their role changed. Owners are set on the server (OWNER_EMAILS).",
  "Доступ по уровню": "Access by level",
  "Уровень доступа определяет, что пользователь может делать в рабочем пространстве.": "The access level defines what a user can do in the workspace.",
  "Вход через Google": "Sign in with Google",
  "Письмо не отправляется: добавленный пользователь сразу входит через Google с этой почтой. Отозванный доступ закрывается мгновенно.":
    "No email is sent: the added user signs in with Google using this address right away. Revoked access is closed instantly.",

  // левое меню настроек (settings-nav.ts)
  "Рабочее пространство": "Workspace",
  "Настройки входящих": "Inbox settings",
  "Данные": "Data",
  "Дашборд": "Dashboard",
  "Общие сведения": "General info",
  "Настройки пользователей": "User settings",
  "Настройки команды": "Team settings",
  "Приложения": "Apps",
  "Каналы": "Channels",
  "Интеграции": "Integrations",
  "Виджеты": "Widgets",
  "Поля контактов": "Contact fields",
  "Жизненный цикл": "Lifecycle",
  "Диалоги": "Conversations",
  "Шаблоны": "Snippets",
  "Теги": "Tags",
  "Звонки": "Calls",
  "Файлы": "Files",
  "Импорт контактов": "Import contacts",

  // окно «Настройки» (settings.tsx)
  "Настройки": "Settings",
  "Рабочие процессы": "Workflows",
  "Отчеты": "Reports",
  "Рассылки": "Broadcasts",
  "Входящие": "Inbox",
  "Контакты": "Contacts",
  "Каталог каналов": "Channel catalog",
  "AI-агенты": "AI agents",
  "Раздел «{label}» пока не открывается": "The “{label}” section is not available yet",
  "Открыт раздел «{label}»": "Opened “{label}”",
  "«{label}» появится в следующих этапах": "“{label}” is coming in a later stage",
  "Уведомления браузера включены": "Browser notifications enabled",
  "Браузер не дал разрешение — включите его в настройках сайта": "The browser denied permission — enable it in the site settings",
  "Тестовое уведомление отправлено — смотрите колокольчик в шапке окна": "Test notification sent — check the bell in the window header",
  "Тест не пришёл: у вас выключены уведомления «Команда и замечания»": "The test did not arrive: your “Team and feedback” notifications are off",
  "настройки рабочего пространства": "workspace settings",
  "Открыть поиск по рабочему пространству": "Open workspace search",
  "Поиск по пространству": "Search workspace",
  "Уведомления, непрочитанных: {n}": "Notifications, {n} unread",
  "Уведомления: {n}": "Notifications: {n}",
  "Уведомления": "Notifications",
  "Все новые уведомления убраны в архив": "All new notifications moved to the archive",
  "Открыт раздел «Уведомления»": "Opened “Notifications”",
  "В": "V",
  "Настройки рабочего пространства": "Workspace settings",
  "Доступы": "Access",
  "Настройки меняют владелец и администраторы. Агенты видят только свои диалоги.": "Settings are changed by the owner and admins. Agents see only their own conversations.",

  // «Настройки пользователей» (users.tsx, usermodal.tsx)
  "доступ отозван": "access revoked",
  "ещё не входил": "has not signed in yet",
  "в сети": "online",
  "Раздел «{label}» в демо не открывается": "The “{label}” section does not open in the demo",
  "Доступ пользователя {name} изменён на «{role}»": "{name}’s access changed to “{role}”",
  "{email} добавлен как «{role}» — теперь он может войти через Google с этой почтой": "{email} added as “{role}” — they can now sign in with Google using this address",
  "Доступ пользователя {name} отозван — он выйдет из Hub при следующем действии": "{name}’s access revoked — they will be signed out of Hub on their next action",
  "Доступ пользователя {name} возвращён": "{name}’s access restored",
  "рабочее пространство → настройки пользователей": "workspace → user settings",
  "Пользователей: {n}": "Users: {n}",
  "Добавлять пользователей могут владелец и администраторы (менеджер с правом «Управление участниками» — агентов). Владельца отключить нельзя.":
    "Users are added by the owner and admins (a manager with the “Manage members” permission can add agents). The owner cannot be disabled.",
  "Управляйте участниками рабочего пространства и приглашайте новых.": "Manage workspace members and invite new ones.",
  "Добавить пользователя": "Add user",
  "Добавлять и менять пользователей могут владелец и администраторы.": "Users are added and changed by the owner and admins.",
  "Поиск по настройкам пользователей": "Search user settings",
  "Поиск по пользователям": "Search users",
  "Загружаем пользователей…": "Loading users…",
  "По запросу «{q}» никого не нашли": "No one found for “{q}”",
  "Попробуйте другую почту или имя, либо очистите поиск.": "Try a different email or name, or clear the search.",
  "Сбросить поиск": "Clear search",
  "(вы)": "(you)",
  "владелец": "owner",
  "добавлен, не входил": "added, not signed in",
  "отключён": "disabled",
  "Отозвать": "Revoke",
  "Посмотреть как": "View as",
  "Посмотреть Hub глазами этого сотрудника: его клиенты, диалоги и разделы. Вернуться — кнопкой в шапке": "See Hub through this employee's eyes: their customers, dialogs and sections. Return via the button in the header",
  "Вернуть доступ": "Restore access",
  "Изменить доступ {name}": "Change access for {name}",
  "Изменить доступ": "Change access",
  "Изменить": "Edit",
  "Все изменения пользователей и входы записываются в «Настройки → Журнал действий».": "All user changes and sign-ins are recorded in “Settings → Activity log”.",
  "Изменить пользователя": "Edit user",
  "Закрыть": "Close",
  "Измените уровень доступа пользователя в рабочем пространстве {brand}.": "Change the user’s access level in the {brand} workspace.",
  "Укажите почту Google сотрудника и уровень доступа. После «Добавить» он сразу сможет войти в {brand} кнопкой «Войти через Google» — письмо не нужно.":
    "Enter the employee’s Google email and access level. After “Add” they can sign in to {brand} with “Sign in with Google” right away — no email needed.",
  "Почта Google": "Google email",
  "Уровень доступа": "Access level",
  "Без корректной почты пользователя не добавить": "A valid email is required to add a user",
  "Дополнительные права": "Additional permissions",
  "Отмена": "Cancel",
  "Сохранить": "Save",
  "Добавить": "Add",

  // «Настройки команды» (teams.tsx, teammodal.tsx, teams-meta.ts, TeamPane)
  "Группируйте сотрудников": "Group your staff",
  "Команда — это набор пользователей, которым можно разом выдать доступ к диалогам и контактам.": "A team is a set of users who can be given access to conversations and contacts all at once.",
  "Раздавайте вместо пользователей": "Assign instead of users",
  "Вместо выбора каждого сотрудника по отдельности назначайте ответственных целой командой.": "Instead of picking each employee separately, assign a whole team as the assignee.",
  "Права остаются личными": "Permissions stay personal",
  "Роль пользователя не меняется: команда только упрощает назначение диалогов и контактов.": "The user’s role does not change: a team only makes assigning conversations and contacts easier.",
  "Команда «{name}» создана — можно назначать ей диалоги и контакты": "Team “{name}” created — you can now assign conversations and contacts to it",
  "Команда «{name}» удалена": "Team “{name}” deleted",
  "Команды создают владелец, администраторы и менеджеры": "Teams are created by the owner, admins and managers",
  "настройки → настройки команды": "settings → team settings",
  "Команд: {n}": "Teams: {n}",
  "Команды создают владелец, администраторы и менеджеры. Роль пользователя при этом не меняется.": "Teams are created by the owner, admins and managers. The user’s role does not change.",
  "Создавайте команды и управляйте ими, чтобы группировать пользователей рабочего пространства.": "Create and manage teams to group workspace users.",
  "Добавить команду": "Add team",
  "Поиск по командам": "Search teams",
  "Пока нет ни одной команды": "No teams yet",
  "Создайте команду, чтобы разом назначать диалоги и контакты группе сотрудников, а не каждому по отдельности.": "Create a team to assign conversations and contacts to a group of employees at once rather than one by one.",
  "Создать команду": "Create team",
  "По запросу «{q}» ничего не нашли": "Nothing found for “{q}”",
  "Попробуйте другое название или очистите поиск.": "Try a different name or clear the search.",
  "участников": "member|members",
  "Без описания": "No description",
  "Участники ещё не добавлены": "No members added yet",
  "Удалить команду {name}": "Delete team {name}",
  "Удалить команду": "Delete team",
  "Команды общие для всего рабочего пространства: их видят все, меняют владелец, администраторы и менеджеры.": "Teams are shared across the workspace: everyone sees them; the owner, admins and managers change them.",
  "Создайте команду, чтобы группировать пользователей. Команды можно назначать вместо отдельных пользователей, когда нужно поделиться ресурсами, например представлениями.":
    "Create a team to group users. Teams can be assigned instead of individual users when you need to share resources, such as views.",
  "Название команды": "Team name",
  "Введите название, например «Маркетинг»": "Enter a name, e.g. “Marketing”",
  "Без названия команду не сохранить": "A name is required to save the team",
  "Описание команды": "Team description",
  "Опишите, чем занимается команда, например «Работа с маркетинговыми контактами»": "Describe what the team does, e.g. “Handling marketing contacts”",
  "Участники команды": "Team members",
  "Добавьте пользователя, например «Иван»": "Add a user, e.g. “John”",
  "Поиск пользователей": "Search users",
  "Никого не нашли — измените запрос": "No one found — change the query",
  "Выбрано: {n} из {total}": "Selected: {n} of {total}",
  "Очистить": "Clear",
  "Участники получат доступ к назначенным команде диалогам и контактам в {brand}.": "Members get access to the conversations and contacts assigned to the team in {brand}.",

  // «Общие сведения» (general.tsx, general-meta.ts)
  "(GMT+01:00) Европа/Рим": "(GMT+01:00) Europe/Rome",
  "(GMT+03:00) Европа/Москва": "(GMT+03:00) Europe/Moscow",
  "(GMT+00:00) Европа/Лондон": "(GMT+00:00) Europe/London",
  "(GMT+01:00) Европа/Берлин": "(GMT+01:00) Europe/Berlin",
  "(GMT+05:00) Азия/Алматы": "(GMT+05:00) Asia/Almaty",
  "(GMT+04:00) Азия/Дубай": "(GMT+04:00) Asia/Dubai",
  "(GMT+09:00) Азия/Токио": "(GMT+09:00) Asia/Tokyo",
  "(GMT−05:00) Америка/Нью-Йорк": "(GMT−05:00) America/New York",
  "Название в письмах": "Name in emails",
  "Название рабочего пространства видно в уведомлениях, дайджесте и в письмах клиентам.": "The workspace name appears in notifications, the digest and emails to customers.",
  "Тайм-аут безопасности": "Security timeout",
  "Если сотрудник неактивен дольше тайм-аута, он выходит из системы и входит через Google заново.": "If an employee is inactive longer than the timeout, they are signed out and sign in with Google again.",
  "Дайджест по понедельникам": "Monday digest",
  "Раз в неделю приходит сводка по диалогам и жизненному циклу — только выбранным получателям.": "A weekly summary of conversations and lifecycle goes out to the selected recipients only.",
  "Тайм-аут неактивности сохранён: {n}": "Inactivity timeout saved: {n}",
  "минут": "minute|minutes",
  "{name} будет получать еженедельный дайджест": "{name} will receive the weekly digest",
  "{name} больше не получает дайджест": "{name} no longer receives the digest",
  "рабочее пространство → общие сведения": "workspace → general info",
  "Часовой пояс: {zone}": "Time zone: {zone}",
  "Общие сведения меняют владелец и администраторы рабочего пространства.": "General info is changed by the workspace owner and admins.",
  "Изменяйте общие настройки рабочего пространства.": "Change the general workspace settings.",
  "Название рабочего пространства": "Workspace name",
  "Название рабочего пространства сохранено": "Workspace name saved",
  "Например, отдел продаж": "e.g. Sales team",
  "Без названия рабочее пространство не сохранить": "A name is required to save the workspace",
  "Тайм-аут неактивности пользователя": "User inactivity timeout",
  "Сколько минут сотрудник может бездействовать, прежде чем система попросит войти заново. Допустимо от 1 до 120 минут.": "How many minutes an employee can be idle before being asked to sign in again. Allowed range: 1 to 120 minutes.",
  "Укажите целое число минут — от 1 до 120": "Enter a whole number of minutes — from 1 to 120",
  "Через {n} бездействия сотрудник выходит из системы.": "After {n} of inactivity the employee is signed out.",
  "Часовой пояс": "Time zone",
  "По этому поясу показываются время диалогов, рабочие часы и дата в дайджесте.": "Conversation times, business hours and the digest date use this time zone.",
  "Часовой пояс сохранён": "Time zone saved",
  "Еженедельный дайджест на почту": "Weekly email digest",
  "Выберите, хотите ли получать краткую сводку по диалогам и результатам жизненного цикла каждый понедельник.": "Choose whether to receive a short summary of conversations and lifecycle results every Monday.",
  "Еженедельный дайджест выключен": "Weekly digest turned off",
  "Еженедельный дайджест включён": "Weekly digest turned on",
  "Получатели": "Recipients",
  "Убрать {name} из получателей": "Remove {name} from recipients",
  "Добавить получателя": "Add recipient",
  "Поиск по имени или почте": "Search by name or email",
  "Поиск получателей": "Search recipients",
  "Все сотрудники уже получают дайджест": "All employees already receive the digest",
  "Получателей: {n}": "Recipients: {n}",
  "Дайджест придёт {n} в понедельник утром.": "The digest goes to {n} on Monday morning.",
  "получателям": "recipient|recipients",
  "Пока не выбран ни один получатель — дайджест отправлять некуда.": "No recipients selected yet — there is no one to send the digest to.",
  "Менять настройки рабочего пространства могут владелец и администраторы.": "Workspace settings can be changed by the owner and admins.",
  "Изменения сохраняются сразу и действуют для всего рабочего пространства.": "Changes are saved immediately and apply to the whole workspace.",

  // вкладки окна «Настройки» (settings-panes.tsx)
  "Сохранить изменения": "Save changes",
  "Основные настройки": "Basic settings",
  "Название, адрес и язык рабочего пространства — то, что видно в письмах, ссылках и уведомлениях команде.": "Workspace name, address and language — what the team sees in emails, links and notifications.",
  "До 60 символов. Видно в письмах клиентам и в уведомлениях.": "Up to 60 characters. Shown in emails to customers and in notifications.",
  "Адрес рабочего пространства": "Workspace address",
  "Ссылка: hub.example/{slug}": "Link: hub.example/{slug}",
  "Только строчные латинские буквы, цифры и дефис — от 3 до 40 символов.": "Lowercase Latin letters, digits and hyphens only — 3 to 40 characters.",
  "Язык интерфейса": "Interface language",
  "Проверьте название и адрес — без них не сохранить": "Check the name and address — both are required to save",
  "Основные настройки сохранены": "Basic settings saved",
  "Одна ссылка для команды": "One link for the team",
  "Ссылку на рабочее пространство можно отправить сотрудникам — они войдут по приглашению.": "Send the workspace link to your staff — they sign in by invitation.",
  "Время в диалогах": "Time in conversations",
  "По выбранному поясу показываются время сообщений, рабочие часы и дата в отчётах.": "Message times, business hours and report dates use the selected time zone.",
  "Настройки общие для всего рабочего пространства. Язык интерфейса пока только русский — выбор сохраняется на будущее.": "Settings are shared across the workspace. The interface language is Russian only for now — your choice is saved for later.",
  "Общая информация": "General information",
  "Описание компании, сайт и отрасль — по этим данным AI-ассистент отвечает клиентам точнее, а отчёты понятнее команде.": "Company description, website and industry — the AI assistant uses them to answer customers more accurately, and reports become clearer for the team.",
  "Описание компании": "Company description",
  "{n} / 500 символов. Коротко: чем занимаетесь и кому продаёте.": "{n} / 500 characters. In short: what you do and whom you sell to.",
  "Сайт": "Website",
  "Почта для уведомлений": "Notification email",
  "Отрасль": "Industry",
  "Размер компании": "Company size",
  "Не выбрано": "Not selected",
  "Общая информация сохранена — AI-ассистент учтёт её в ответах": "General information saved — the AI assistant will use it in replies",
  "Менять общую информацию могут владелец и администраторы.": "General information can be changed by the owner and admins.",
  "По этим данным AI-ассистент будет отвечать клиентам (этап 6).": "The AI assistant will use this data to reply to customers (stage 6).",
  "Настройки ролей пользователей": "User role settings",
  "Участники рабочего пространства: приглашение по почте Google, роли, отзыв доступа, «Посмотреть как».": "Workspace members: invite by Google email, roles, revoke access, \"View as\".",
  "Роль определяет, что сотрудник видит и может менять в рабочем пространстве. Включите нужные права — они применятся ко всем пользователям этой роли.": "A role defines what an employee sees and can change in the workspace. Turn on the permissions you need — they apply to every user with this role.",
  "пользователей": "user|users",
  "{on} из {total} прав": "{on} of {total} permissions",
  "{perm} для роли {role}": "{perm} for the {role} role",
  "Права ролей сохранены — изменения применятся при следующем входе": "Role permissions saved — changes apply at the next sign-in",
  "Сохранить роли": "Save roles",
  "Права ролей возвращены к значениям по умолчанию": "Role permissions reset to defaults",
  "Сбросить": "Reset",
  "Владелец рабочего пространства всегда имеет полный доступ — его права не отключаются.": "The workspace owner always has full access — their permissions cannot be turned off.",
  "Поле «{label}» добавлено в карточку контакта — ID {key}": "Field “{label}” added to the contact card — ID {key}",
  "Встроенное поле «{label}» удалить нельзя — его можно только скрыть": "Built-in field “{label}” cannot be deleted — it can only be hidden",
  "Удалить поле «{label}»? Его значения будут стёрты из всех карточек контактов.": "Delete field “{label}”? Its values will be erased from all contact cards.",
  "Поле «{label}» удалено из карточки контакта": "Field “{label}” removed from the contact card",
  "Пользовательские настройки полей": "Custom field settings",
  "Соберите карточку клиента под свой отдел продаж: город, номер договора, сегмент и любые другие поля. Скрытые поля не показываются в карточке.": "Build the customer card for your sales team: city, contract number, segment and any other fields. Hidden fields are not shown on the card.",
  "Название поля": "Field name",
  "Например, номер договора": "e.g. Contract number",
  "Тип": "Type",
  "Добавить поле": "Add field",
  "Поиск по полям": "Search fields",
  "Показано {n} из {total}": "Showing {n} of {total}",
  "Загружаем поля…": "Loading fields…",
  "Поле не найдено — измените запрос.": "Field not found — change the query.",
  "системное": "system",
  "Показывать поле {label}": "Show field {label}",
  "Удалить поле {label}": "Delete field {label}",
  "Удалить поле": "Delete field",
  "Изменения сохраняются сразу. Тип, описание и видимость «Только админ» — в разделе «Поля контактов».": "Changes are saved immediately. Type, description and “Admin only” visibility are in “Contact fields”.",
  "У вас только просмотр: поля меняют владелец и администраторы.": "View only: fields are changed by the owner and admins.",
  "Команды группируют сотрудников, чтобы назначать диалоги и контакты группе целиком, а не каждому по отдельности.": "Teams group employees so you can assign conversations and contacts to the whole group rather than to each person.",
  "Например, ночная смена": "e.g. Night shift",
  "Описание": "Description",
  "Чем занимается команда": "What the team does",
  "Участники": "Members",
  "Выбрано участников: {n}": "Members selected: {n}",
  "Пока нет ни одной команды — создайте первую, чтобы группировать сотрудников.": "No teams yet — create the first one to group your staff.",
  "Удалить": "Delete",
  "Роль пользователя при добавлении в команду не меняется: команда только упрощает назначение.": "Adding a user to a team does not change their role: a team only makes assigning easier.",
  "Дополнительные приложения рабочего пространства. Включайте нужные — они появятся в меню у всей команды.": "Additional workspace apps. Turn on the ones you need — they appear in the menu for the whole team.",
  "Включено: {n}": "Enabled: {n}",
  "Всего приложений: {n}": "Total apps: {n}",
  "Приложение {name}": "App {name}",
  "Приложение «{name}» включено и появилось в меню": "App “{name}” enabled and added to the menu",
  "Приложение «{name}» выключено": "App “{name}” disabled",
  "Демо-режим: включение приложения живёт только на этой странице.": "Demo mode: enabling an app only lasts on this page.",
  "Свяжите Hub с CRM, таблицами и складом — контакты, сделки и остатки будут обновляться синхронно, без ручного переноса.": "Connect Hub to your CRM, spreadsheets and warehouse — contacts, deals and stock stay in sync without manual transfer.",
  "Подключено: {n}": "Connected: {n}",
  "Доступно: {n}": "Available: {n}",
  "Подключено": "Connected",
  "Интеграция «{name}» подключена": "Integration “{name}” connected",
  "Интеграция «{name}» отключена, данные остались в Hub": "Integration “{name}” disconnected; the data stays in Hub",
  "Отключить": "Disconnect",
  "Подключить": "Connect",
  "Демо-режим: подключение имитируется в макете и не затрагивает реальные сервисы.": "Demo mode: the connection is simulated in the mock-up and does not touch real services.",
  "Zoho CRM и Books": "Zoho CRM & Books",
  "Синхронизация с Zoho, история переписки Wazzup и продавцы Sales Person → сотрудники Hub.": "Zoho sync, Wazzup chat history and Sales Person → Hub staff mapping.",
  "Только чтение: компании и клиенты Books, история переписки Wazzup и распределение диалогов по продавцам Zoho (поле Sales Person) между сотрудниками Hub.": "Read-only: companies and Books customers, Wazzup chat history and distribution of conversations to Hub staff by the Zoho Sales Person field.",
  "Открыть сопоставление клиентов Books": "Open Books customer matching",
  "Ключи Zoho задаются в настройках сервера; здесь — запуск синхронизации, докачка истории Wazzup и привязка продавцов к сотрудникам.": "Zoho keys live in the server settings; here you run the sync, fetch new Wazzup history and link salespersons to staff.",
  "Варианты поля «{label}» сохранены": "Options of field “{label}” saved",
  "Через запятую: опт, розница, дилер": "Comma-separated: wholesale, retail, dealer",
  "Варианты поля {label}": "Options of field {label}",
  "Варианты": "Options",
  "не заданы — в карточке можно вводить любые значения": "not set — any value can be typed in the card",
  "Изменить варианты": "Edit options",
  "Задать варианты": "Set options",
  "Изменения сохраняются сразу. Варианты списка — по ссылке «Задать варианты» у поля; тип, описание и видимость «Только админ» — в разделе «Поля контактов».": "Changes are saved immediately. List options — via “Set options” next to the field; type, description and “Admin only” visibility — in the “Contact fields” section.",
  "Клиенты": "Clients",
  "видит": "sees",
  "Переслано сообщение": "Message forwarded",
  "открытый диалог": "open dialog|open dialogs",
  "показать": "show",
  "открыть компании": "open companies",
  "Ответственный за контакт": "Contact owner",
  "Ответственный за компанию": "Company owner",
  "Слиты дубли контакта": "Contact duplicates merged",
  "Слиты дубли компании": "Company duplicates merged",
  "Вопрос базе знаний": "Knowledge base question",
  "Запущено слияние дублей": "Duplicate merge started",
  "компаний": "company|companies",
  "контактов": "contact|contacts",
  "сделок": "deal|deals",
};
export default d;
